import { render, staticRenderFns } from "./forgetPwd.vue?vue&type=template&id=0e137849&scoped=true&"
import script from "./forgetPwd.vue?vue&type=script&lang=js&"
export * from "./forgetPwd.vue?vue&type=script&lang=js&"
import style0 from "./forgetPwd.vue?vue&type=style&index=0&id=0e137849&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e137849",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e137849')) {
      api.createRecord('0e137849', component.options)
    } else {
      api.reload('0e137849', component.options)
    }
    module.hot.accept("./forgetPwd.vue?vue&type=template&id=0e137849&scoped=true&", function () {
      api.rerender('0e137849', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/loginPublic/forgetPwd.vue"
export default component.exports